import React from 'react';
import { Link } from 'react-router-dom';
import { formatCategoryPath } from '../utils';

const CategoryTags = ({ categoryPath, hasStandard, tags = [], buildCategoryHref }) => {
    const hasCategory = Boolean(categoryPath && formatCategoryPath(categoryPath));
    const hasTags = hasStandard && Array.isArray(tags) && tags.length > 0;

    if (!hasCategory && !hasTags) {
        return null;
    }

    return (
        <div className="mt-4 flex flex-col gap-3">
            {hasCategory && (
                <div className="text-sm text-secondary-600">
                    Категория:{' '}
                    <span className="text-secondary-900 font-medium">
                        {categoryPath?.main ? (
                            <>
                                <Link to={buildCategoryHref(categoryPath.main)} className="hover:underline">
                                    {categoryPath.main.name}
                                </Link>
                                {categoryPath.sub?.name ? (
                                    <>
                                        {' / '}
                                        <Link to={buildCategoryHref(categoryPath.sub)} className="hover:underline">
                                            {categoryPath.sub.name}
                                        </Link>
                                    </>
                                ) : null}
                                {categoryPath.subSub?.name ? (
                                    <>
                                        {' / '}
                                        <Link to={buildCategoryHref(categoryPath.subSub)} className="hover:underline">
                                            {categoryPath.subSub.name}
                                        </Link>
                                    </>
                                ) : null}
                            </>
                        ) : (
                            formatCategoryPath(categoryPath)
                        )}
                    </span>
                </div>
            )}

            {hasTags && (
                <div className="flex flex-wrap gap-2">
                    {tags.map((t) => {
                        const tag = String(t || '').trim();
                        if (!tag) return null;
                        return (
                            <Link
                                key={tag}
                                to={`/tag/${encodeURIComponent(tag)}`}
                                className="px-2 py-1 rounded-full bg-secondary-50 border border-secondary-200 text-sm text-secondary-800 hover:bg-secondary-100 hover:underline"
                                title={`#${tag}`}
                            >
                                #{tag}
                            </Link>
                        );
                    })}
                </div>
            )}
        </div>
    );
};

export default CategoryTags;
